<template>
    <el-select v-model="selectValue" :size="size" :clearable="clearable" 
    :disabled="disabled" :multiple-limit="multipleLimit" :filterable="filterable"
    :multiple="multiple" :placeholder="placeholder" @change="onChange">
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: '请选择'
            },
            size: {
                type: String,
                default: ''
            },
            value: {
                type: [Number,String,Array]
            },
            clearable: {    //是否可以清空选项
                type: Boolean,
                default: false
            },
            multiple: {     //是否多选
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            multipleLimit: {     //多选时用户最多可以选择的项目数，为 0 则不限制
                type: Number,
                default: 0
            },
            filterable: {       //是否可搜索
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selectValue: this.value
            }
        },
        created() {
            this.options.forEach(it => {
                if(it.selected) {
                    this.selectValue = it.id
                }                
            })
        },
        methods: {
            onChange(val) {
                this.$emit('input', val)
            }
        },
        watch: {
            'value': {
                handler: function(val) {
					this.$nextTick(() => {
						this.selectValue = val
					})
				},
				immediate: true
            }
        }
    }
</script>

<style scoped>

</style>